import styled, { css } from 'styled-components';

export const StyledSidebarButton = styled.button<{ $isActive: boolean }>`
  width: 100%;
  min-width: 0;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border-radius: 0.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.dark};
  padding: 0.25rem 0;
  box-sizing: border-box;
  text-align: left;

  &:hover {
    background: ${({ theme }) => theme.primary90};
    border-radius: 0.5rem;
    color: ${({ theme }) => theme.primary};
  }

  ${(props) =>
    props.$isActive &&
    css`
      background: ${({ theme }) => theme.primary90};
      border-radius: 0.5rem;
      color: ${({ theme }) => theme.primary};
    `}
`;

export const StyledIcon = styled.span`
  /* Left padding is the row's inset; the space to the label is the flex gap
     alone, so it is set in one place rather than added to twice. */
  padding: 0.25rem 0 0.25rem 0.75rem;
  min-width: 1.25rem;
  display: flex;
  width: 1rem;
  flex-shrink: 0;
`;

export const StyledSidebarLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* The list already insets the row by 1rem, so this only has to keep the text
     off the hover background's rounded edge. */
  padding-right: 0.25rem;
`;
